import React, { ReactNode } from 'react'
import styled, { keyframes } from 'styled-components'

const toggle = keyframes`
  from { opacity: 0; }
  to { opacity: 0.6; }
`

const Container = styled.div<{ open?: boolean }>`
  animation: ${toggle} 0.3s ease-in-out;
  background: rgba(0, 0, 0, 0.6);
  display: ${({ open }) => (open ? 'block' : 'none')};
  height: 100%;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 8000;
`

export default function Overlay({ children, open }: { children?: ReactNode; open?: boolean }) {
  return <Container open={open}>{children}</Container>
}
